import Vue from "vue";
import Router from "vue-router";
import store from "@/store/";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import LoginApi from "@/services/login";
import Productos from "./views/Productos.vue";
import Seguimiento from "./views/Seguimiento.vue";
import SeguimientoC from "./views/SeguimientoC.vue";
import Iconos from "./views/Iconos.vue";
import Vendedores from "./views/Vendedores.vue";
import Permisos from "./views/Permisos.vue";
import SinPermiso from "./views/SinPermiso.vue";
import Supervisores from "./views/Supervisores.vue";
import Contacto from "./views/Contacto.vue";
import Quienes from "./views/Quienes.vue";
import Categoria from "./views/Categoria.vue";
import ClientesWeb from "./views/ClientesWeb.vue";
import Grupo from "./views/Grupo.vue";
import Cobros from "./views/Cobros.vue";
import Tickets from "./views/Tickets.vue";
import Banners from "./views/Banners.vue";
import Carousel from "./views/Carousel.vue";
import Solicitudes from "./views/Solicitudes.vue";
import Departamentos from "./views/Departamentos.vue";
import Devoluciones from "./views/Devoluciones.vue";
import CategoriaWeb from "./views/CategoriaWeb.vue";
import Subcategoria from "./views/Subcategoria.vue";
import Movimientos from "./views/Movimientos.vue";
import Marcas from "./views/Marcas.vue";
import Settings from "./views/Settings.vue";
import Valija from "./views/Valija.vue";
import Linea from "./views/Linea.vue";
import MetodoPago from "./views/MetodoPago.vue";
import Promociones from "./views/Promociones.vue";
import Dispositivos from "./views/Dispositivos.vue";
import CoordenadasClientes from "./views/CoordenadasClientes.vue";
import ContactoClientes from "./views/ContactoClientes.vue";
import ImagenClientes from "./views/ImagenClientes.vue";
import Tareas from "./views/Tareas.vue";
import CuentasBancarias from "./views/CuentasBancarias.vue";
import QuinielaEquipos from "./views/QuinielaEquipos.vue";
import QuinielaPartidos from "./views/QuinielaPartidos.vue";
import QuinielaAdmin from "./views/QuinielaAdmin.vue";
import CotizacionesTemporales from "./views/CotizacionesTemporales.vue";
import Reclamos from "./views/Reclamos.vue";
import Cuestionarios from "./views/Cuestionarios.vue";
import Peticiones from "./views/Peticiones.vue";
import { Loading } from "element-ui";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/cuentasBancarias",
      name: "cuentasBancarias",
      component: CuentasBancarias,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/tareas",
      name: "tareas",
      component: Tareas,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/coordenadas-clientes",
      name: "coordenadas-clientes",
      component: CoordenadasClientes,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/contacto-clientes",
      name: "contacto-clientes",
      component: ContactoClientes,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/imagen-clientes",
      name: "imagen-clientes",
      component: ImagenClientes,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/cotizaciones-temporales",
      name: "cotizaciones-temporales",
      component: CotizacionesTemporales,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/reclamos",
      name: "reclamos",
      component: Reclamos,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/cuestionarios",
      name: "cuestionarios",
      component: Cuestionarios,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/peticiones",
      name: "peticiones",
      component: Peticiones,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/banners",
      name: "banners",
      component: Banners,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/grupo",
      name: "grupo",
      component: Grupo,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/valija",
      name: "valija",
      component: Valija,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/metodoPago",
      name: "metodoPago",
      component: MetodoPago,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/promociones",
      name: "promociones",
      component: Promociones,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/dispositivos",
      name: "dispositivos",
      component: Dispositivos,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/contacto",
      name: "contacto",
      component: Contacto,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/devoluciones",
      name: "devoluciones",
      component: Devoluciones,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/movimientos",
      name: "movimientos",
      component: Movimientos,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/quienes",
      name: "quienes",
      component: Quienes,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/carousel",
      name: "carousel",
      component: Carousel,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/clientesWeb",
      name: "clientesWeb",
      component: ClientesWeb,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/departamentos",
      name: "departamentos",
      component: Departamentos,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/categoriaWeb",
      name: "categoriaWeb",
      component: CategoriaWeb,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/subcategoria",
      name: "subcategoria",
      component: Subcategoria,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/marcas",
      name: "marcas",
      component: Marcas,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/home",
      name: "home",
      component: Home,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/",
      name: "login",
      component: Login,
      meta: {
        isPublic: true,
        isLog: true
      }
    },
    {
      path: "/tickets",
      name: "tickets",
      component: Tickets,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/solicitudes",
      name: "solicitudes",
      component: Solicitudes,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/supervisores",
      name: "supervisores",
      component: Supervisores,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/cobros",
      name: "cobros",
      component: Cobros,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/linea",
      name: "linea",
      component: Linea,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/iconos",
      name: "iconos",
      component: Iconos,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/categoria",
      name: "categoria",
      component: Categoria,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/vendedores",
      name: "vendedores",
      component: Vendedores,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/seguimiento",
      name: "seguimiento",
      component: Seguimiento,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/seguimientoc",
      name: "seguimientoc",
      component: SeguimientoC,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/productos",
      name: "productos",
      component: Productos,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/sinpermiso",
      name: "sinpermiso",
      component: SinPermiso,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/permisos",
      name: "permisos",
      component: Permisos,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/quiniela-equipos",
      name: "quiniela-equipos",
      component: QuinielaEquipos,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/quiniela-partidos",
      name: "quiniela-partidos",
      component: QuinielaPartidos,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/quiniela-admin",
      name: "quiniela-admin",
      component: QuinielaAdmin,
      meta: {
        isPublic: false
      }
    }
  ]
});
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.isPublic);
  if (requiresAuth === false) {
    LoginApi.refreshtoken()
      .then(res => {
        store.dispatch("setuser", res.data.usuario);
        if (to.path == "/valija") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Valijas") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/cuentasBancarias") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Cuentas Bancarias") {
                bols = true;
                for (let j = 0; j < store.state.adminemanuel.permisos[i].accion.length; j++) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            next("/sinpermiso");
          }
        } else if (to.path == "/metodoPago") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Metodo de Pago") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/movimientos") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Movimientos") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/quienes") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Acerca de nosotros") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/devoluciones") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Devoluciones") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/contacto") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Contacto") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/grupo") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Grupo") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/clientesWeb") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "ClientesWeb") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/carousel") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Carousel") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/banners") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Banners") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/marcas") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Marcas") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/subcategoria") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Subcategoria") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/categoriaWeb") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "CategoriaWeb") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/departamentos") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Departamentos") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/tickets") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Tickets") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/settings") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Configuraciones") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/productos") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Productos") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/permisos") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Empleados") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/seguimientoc") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Seguimiento Cotizacion") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/seguimiento") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Seguimiento") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/iconos") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Iconos") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/supervisores") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Supervisores") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/categoria") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Categoria") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/linea") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Linea") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/cobros") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Cobros") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/solicitudes") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.adminemanuel.permisos) {
            for (let i = 0; i < store.state.adminemanuel.permisos.length; i++) {
              if (store.state.adminemanuel.permisos[i].ruta === "Solicitudes") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.adminemanuel.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.adminemanuel.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else {
          next();
        }
      })
      .catch(error => {
        console.log(error);
        next("/");
      });
  } else {
    if (to.path == "/") {
      LoginApi.refreshtoken()
        .then(res => {
          store.dispatch("setuser", res.data.usuario);
          next("/home");
        })
        .catch(error => {
          console.log(error);
          //next("/login")
        });
    }
    next();
  }
});

export default router;
